// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"608":"c30f2dec","912":"7d429f49"}[chunkId] + ".chunk.css";
};